<!-- DARK THEME DASHBOARD / HOMEPAGE -->
<main class="bg-black text-white min-h-screen overflow-x-hidden" role="main">

  <!-- HERO SECTION -->
  <section #target class="relative min-h-[90vh] flex items-center pt-24 pb-20 overflow-hidden"
    aria-label="Hero section">
    <!-- Three.js Canvas with directive -->
    <canvas appHeroCanvas id="heroCanvas" class="absolute inset-0 w-full h-full" aria-hidden="true"></canvas>

    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="grid gap-10 md:gap-16 items-center lg:grid-cols-[1.6fr,0.4fr]">
        <!-- Hero Text Content -->
        <div class="text-left space-y-5 md:space-y-6">
          <h1 class="text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] max-w-5xl">
            <span class="block md:whitespace-nowrap text-white text-balance lg:text-7xl">Creating the Future of Connectivity
              <br><span class="text-varroc-accent text-3xl sm:text-4xl lg:text-5xl"> Backed by data, driven by intelligence, built for scale.
          </span></span>
          </h1>

          <p class="max-w-5xl text-lg leading-relaxed text-varroc-text-gray">
            Varroc Connect delivers advanced IoT solutions, smart mobility solutions, IIOT ecosystems, connected hardware devices, and digital engagement platforms designed to transform how enterprises, vehicles, devices, and users interact. From Enterprise Fleet Management and predictive analytics to intelligent automation and connected experiences, our ecosystem helps businesses improve visibility, enhance safety, optimize performance, and enable smarter real-time decision-making.          </p>
         <p class="max-w-5xl text-lg leading-relaxed text-varroc-text-gray">
            Built for evolving digital ecosystems, Varroc Connect combines connectivity, intelligence, and scalable technology platforms to create seamless, data-driven experiences across industries.
         </p>
          <!-- Dual CTA Buttons for B2B and B2C -->
          <div class="mt-10 flex flex-col sm:flex-row gap-4 justify-start w-full sm:w-auto">
            <a routerLink={{Routes.contact}} title="Book a demo for business solutions"
              class="group w-full sm:w-auto bg-varroc-accent px-8 py-4 rounded-md hover:bg-varroc-accent-hover transition-all duration-300 font-semibold text-lg text-center relative overflow-hidden">
              <span class="relative z-10 home_book_enterprises_demo_button">Book Enterprise Demo</span>
              <span
                class="absolute inset-0 bg-white/10 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></span>
            </a>
            <a routerLink="/store/product" title="Shop connected vehicle devices"
              class="group w-full sm:w-auto border-2 border-varroc-accent px-8 py-4 rounded-md hover:bg-varroc-accent transition-all duration-300 font-semibold text-lg text-center">
              <span class="flex items-center justify-center gap-2 home_shop_devices_button">
                <i class='bx bx-shopping-bag text-xl'></i>
                Shop Devices
              </span>
            </a>
          </div>

          <!-- Trust Indicators -->
          <div class="mt-8 flex items-center gap-6 justify-start text-sm">
            <div class="flex items-center gap-2">
              <i class='bx bx-check-shield icon-gradient text-2xl'></i>
              <span class="text-varroc-text-gray">Enterprise-Grade Security</span>
            </div>
            <div class="flex items-center gap-2">
              <i class='bx bx-trending-up icon-gradient text-2xl'></i>
              <span class="text-varroc-text-gray">500K+ Connected Vehicles</span>
            </div>
          </div>
        </div>

        <!-- Hero Visual -->
        <!-- <div class="hidden md:block">
          <div class="feature-card bg-gradient-to-br from-varroc-dark via-black to-varroc-dark border-varroc-accent/20 p-8 lg:p-10">
            <span class="text-varroc-accent font-semibold text-sm uppercase tracking-[0.22em]">Why Choose Us</span>
            <h2 class="text-2xl lg:text-3xl font-bold text-white mt-4 mb-4">Trusted by Industry Leaders</h2>
            <p class="text-varroc-text-gray leading-relaxed mb-6">
              Built for scale and reliability, our platform powers connected ecosystems for leading OEMs and enterprises, delivering proven performance, security, and innovation.
            </p>
            <div class="grid gap-4">
              <div class="rounded-2xl border border-white/10 bg-white/5 p-4">
                <div class="text-white font-semibold mb-1">For Businesses</div>
                <div class="text-varroc-text-gray text-sm">Accelerate digital transformation, open new revenue streams, improve efficiency, and create personalized connected experiences.</div>
              </div>
              <div class="rounded-2xl border border-white/10 bg-white/5 p-4">
                <div class="text-white font-semibold mb-1">For Individuals</div>
                <div class="text-varroc-text-gray text-sm">Stay informed with real-time insights, drive safer, access rewards, and enjoy a smarter connected ownership experience.</div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>

  <!-- WHY VARROC CONNECT -->
  <section class="dashboard-section bg-gradient-to-b from-black via-varroc-darker to-black" aria-labelledby="why-heading">
    <div class="max-w-7xl mx-auto px-6">
      <!-- Mission Statement -->
      <div class="dashboard-section-header text-left space-y-4">
        <span class="text-varroc-accent font-semibold text-sm uppercase tracking-wider">Why Choose Us</span>
        <h2 id="why-heading" class="dashboard-major-title text-3xl md:text-5xl font-bold text-white">Why Enterprises Choose Our Connected Technology & Intelligent Platform Solutions</h2>
        <p class="max-w-4xl text-lg leading-relaxed text-varroc-text-gray">
          Built for scale and reliability, our platform powers connected ecosystems for leading OEMs and enterprises while delivering proven performance, security, and innovation across business and consumer journeys.
        </p>
      </div>

      <!-- Quick Navigation - B2B vs B2C -->
      <div class="grid md:grid-cols-2 gap-8 dashboard-major-gap">
        <!-- For Businesses -->
        <div class="feature-card group" routerLink={{Routes.solutions_business}} title="Explore solutions for businesses">
          <div class="flex items-start gap-4 mb-6">
            <div class="w-12 h-12 bg-varroc-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <i class='bx bx-buildings text-2xl icon-gradient'></i>
            </div>
            <div>
              <h3 class="text-xl font-bold text-white mb-2">For Businesses</h3>
              <ul class="space-y-2 mb-4 text-sm leading-relaxed text-varroc-text-gray">
                <li>Accelerate digital transformation with a unified connected platform.</li>
                <li>Enable new revenue streams through services, subscriptions, and marketplaces.</li>
                <li>Improve operational efficiency with real-time insights and automation.</li>
                <li>Enhance customer engagement with personalized, data-driven experiences.</li>
              </ul>
            </div>
          </div>
          <div class="flex flex-wrap gap-3">
            <a routerLink={{Routes.cariq_automotive_solution}}
              class="text-sm text-varroc-accent hover:text-white transition">OEMs</a>
            <span class="text-varroc-border">•</span>
            <a routerLink={{Routes.cariq_bfsi}}
              class="text-sm text-varroc-accent hover:text-white transition">Insurance</a>
            <span class="text-varroc-border">•</span>
            <a routerLink={{Routes.cariq_tls_solution}}
              class="text-sm text-varroc-accent hover:text-white transition">Fleet & Logistics</a>
          </div>
          <a routerLink={{Routes.contact}}
            class="mt-6 inline-flex items-center gap-2 text-varroc-accent font-medium group-hover:gap-3 transition-all">
            <span>Get Started</span>
            <i class='bx bx-right-arrow-alt text-xl'></i>
          </a>
        </div>

        <!-- For Individuals -->
        <div class="feature-card group" routerLink={{Routes.solutions_consumers}} title="Explore solutions for individuals">
          <div class="flex items-start gap-4 mb-6">
            <div class="w-12 h-12 bg-varroc-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <i class='bx bx-user text-2xl icon-gradient'></i>
            </div>
            <div>
              <h3 class="text-xl font-bold text-white mb-2">For Individuals</h3>
              <ul class="space-y-2 mb-4 text-sm leading-relaxed text-varroc-text-gray">
                <li>Stay informed with real-time vehicle insights and alerts.</li>
                <li>Experience safer driving with proactive notifications and assistance.</li>
                <li>Access value-added services and rewards seamlessly.</li>
                <li>Enjoy a smarter, more connected ownership experience.</li>
              </ul>
            </div>
          </div>
          <div class="flex flex-wrap gap-3">
            <a routerLink="/store/product" class="text-sm text-varroc-accent hover:text-white transition">Smart
              Devices</a>
            <span class="text-varroc-border">•</span>
            <a routerLink="/store/product" class="text-sm text-varroc-accent hover:text-white transition">Mobile
              Apps</a>
            <span class="text-varroc-border">•</span>
            <a routerLink={{Routes.cariq_vehicleusers}}
              class="text-sm text-varroc-accent hover:text-white transition">Rewards</a>
          </div>
          <a routerLink="/store/product"
            class="mt-6 inline-flex items-center gap-2 text-varroc-accent font-medium group-hover:gap-3 transition-all">
            <span>Shop Now</span>
            <i class='bx bx-shopping-bag text-xl'></i>
          </a>
        </div>
      </div>

      <!-- Platform Overview Section -->
      <div>
        <div class="dashboard-section-header text-left">
          <span class="text-varroc-accent font-semibold text-sm uppercase tracking-wider">Our Key Differentiators</span>
          <h2 class="dashboard-major-title text-3xl md:text-4xl font-bold text-white mt-4">Advanced Connected Capabilities for Mobility, IIOT & Engagement Platforms</h2>
          <p class="max-w-5xl text-lg leading-relaxed text-varroc-text-gray">
          Varroc Connect delivers a powerful connected car platform designed to enable seamless mobility experiences, real-time vehicle tracking, intelligent communication, and connected automotive solutions at scale. From fleet visibility and driver engagement to data-led insights and connected commerce, our integrated ecosystem helps businesses launch, manage, and optimize smarter connected experiences through real-time intelligence and scalable digital infrastructure.
          </p>
        </div>

        <!-- Platform Grid -->
        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <a *ngFor="let item of differentiators"
            [routerLink]="item.route"
            class="feature-card group block h-full no-underline cursor-pointer hover:border-varroc-accent/60 transition-all duration-300">
            <div
              class="w-14 h-14 bg-varroc-accent/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
              <i class='bx text-3xl icon-gradient' [class]="item.icon"></i>
            </div>
            <h3 class="text-xl font-bold text-white mb-3 group-hover:text-varroc-accent transition-colors">{{ item.title }}</h3>
            <p class="text-varroc-text-gray text-sm leading-relaxed mb-4">{{ item.desc }}</p>
            <div class="flex flex-wrap gap-2 mt-auto">
              <span *ngFor="let tag of item.tags" class="px-3 py-1 bg-varroc-accent/10 text-varroc-accent text-xs rounded-full">{{ tag }}</span>
            </div>
          
          </a>
        </div>

        <!-- Platform CTA -->
        <div class="mt-12">
          <a routerLink={{Routes.contact}}
            class="inline-flex items-center gap-2 text-varroc-accent hover:text-white font-semibold transition-all group">
            <span>Explore Platform Capabilities</span>
            <i class='bx bx-right-arrow-alt text-2xl group-hover:translate-x-1 transition-transform'></i>
          </a>
        </div>
      </div>

    </div>
  </section>

  <section class="dashboard-section">
    <div class="max-w-7xl mx-auto px-6">
    <div class="dashboard-section-header text-left max-w-3xl">
      <span class="text-varroc-accent font-semibold text-sm uppercase tracking-[0.22em]">Platform Performance</span>
      <h2 class="dashboard-major-title text-3xl md:text-4xl font-bold text-white mt-4">High-Performance Connected Platforms, IIOT & Smart Device Ecosystems</h2>
      <p class="text-varroc-text-gray text-lg leading-relaxed">From event ingestion to low-latency APIs and global availability, the platform is designed to support high-volume connected ecosystems without compromising responsiveness, reliability, or operational control.</p>
    </div>
    <!-- Platform Performance -->
    <div class="relative overflow-hidden rounded-[2rem] border border-varroc-border bg-gradient-to-br from-varroc-dark via-black to-varroc-dark p-8 md:p-12">
      <div class="absolute -top-16 right-0 h-48 w-48 rounded-full bg-varroc-accent/10 blur-3xl pointer-events-none"></div>
      <div class="relative z-10 grid sm:grid-cols-2 gap-5 text-left">
          <div class="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
            <h3 class="text-4xl font-bold text-varroc-accent mb-2">100K+</h3>
            <div class="text-white font-semibold mb-2">Events per Minute</div>
            <div class="text-varroc-text-gray text-sm leading-relaxed">Real-time data processing capacity for connected devices, vehicles, and user interactions.</div>
          </div>
          <div class="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
            <h3 class="text-4xl font-bold text-varroc-accent mb-2">&lt;100ms</h3>
            <div class="text-white font-semibold mb-2">API Latency</div>
            <div class="text-varroc-text-gray text-sm leading-relaxed">Fast response times that support real-time alerts, contextual messaging, and connected app experiences.</div>
          </div>
          <div class="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
            <h3 class="text-4xl font-bold text-varroc-accent mb-2">99.99%</h3>
            <div class="text-white font-semibold mb-2">SLA Uptime</div>
            <div class="text-varroc-text-gray text-sm leading-relaxed">Enterprise-grade availability engineered for mission-critical automotive and mobility programs.</div>
          </div>
          <div class="rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
            <h3 class="text-4xl font-bold text-varroc-accent mb-2">Global</h3>
            <div class="text-white font-semibold mb-2">Multi-Region Reach</div>
            <div class="text-varroc-text-gray text-sm leading-relaxed">Flexible deployment footprint to support regional scaling, governance, and worldwide connected operations.</div>
          </div>
      </div>
    </div>
    </div>
  </section>

  <!-- TESTIMONIALS SECTION -->
  <section class="dashboard-section bg-gradient-to-b from-black via-varroc-darker to-black relative overflow-hidden">
    <!-- Decorative Background Elements -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="absolute top-20 left-10 w-64 h-64 bg-varroc-accent/5 rounded-full blur-3xl"></div>
      <div class="absolute bottom-20 right-10 w-96 h-96 bg-varroc-accent/5 rounded-full blur-3xl"></div>
    </div>

    <div class="max-w-7xl mx-auto px-6 relative z-10">
      <!-- Section Header -->
      <div class="dashboard-section-header text-left">
        <h2 class="dashboard-major-title text-4xl md:text-5xl font-bold text-white">Connected Solutions Across Mobility, Enterprise Operations & Customer Experiences</h2>
        <p class="max-w-3xl text-lg leading-relaxed text-varroc-text-gray mb-6">
          The same connected platform supports enterprise transformation, smarter operations, richer in-vehicle experiences, and stronger end-user engagement through one scalable ecosystem.
        </p>
        <div class="inline-flex items-center gap-2 rounded-full border border-varroc-border bg-white/5 px-4 py-2 text-sm text-varroc-text-gray">
          <i class='bx bx-check-shield icon-gradient text-xl'></i>
          Trusted for scale, reliability, security, and continuous innovation.
        </div>
      </div>

      <div class="relative">
        <div class="flex gap-6 overflow-x-auto scroll-smooth pb-4" #testimonialsContainer
          style="scrollbar-width: none; -ms-overflow-style: none;">

          <div class="flex-shrink-0 w-80 md:w-96 relative group">
            <div
              class="absolute inset-0 bg-gradient-to-br from-varroc-accent/20 to-transparent rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            </div>
            <div
              class="relative bg-gradient-to-br from-varroc-dark to-black border border-varroc-border p-8 rounded-3xl flex flex-col gap-6 min-h-[360px] card-hover">
              <div class="flex justify-between items-start">
                <div class="w-12 h-12 bg-varroc-accent/10 rounded-xl flex items-center justify-center">
                  <svg class="w-7 h-7 svg-fill-gradient" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
                  </svg>
                </div>
                <span class="text-xs font-semibold uppercase tracking-[0.22em] text-varroc-accent">Business</span>
              </div>

              <p class="flex-grow text-varroc-text-gray leading-relaxed">Accelerate digital transformation with a unified connected platform that helps OEMs and enterprises launch services faster, respond in real time, and scale with confidence.</p>

              <div class="flex items-center gap-4 pt-4 border-t border-varroc-border">
                <div class="relative">
                  <img [src]="Images.CUSTOMER_1"
                    class="h-14 w-14 rounded-full object-cover ring-2 ring-varroc-accent/50">
                  <div
                    class="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-varroc-dark">
                  </div>
                </div>
                <div class="flex-1">
                  <p class="font-bold text-white text-lg">OEM & Enterprise Teams</p>
                  <p class="text-sm text-varroc-text-gray">Digital transformation and connected service delivery</p>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-shrink-0 w-80 md:w-96 relative group">
            <div
              class="absolute inset-0 bg-gradient-to-br from-varroc-accent/20 to-transparent rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            </div>
            <div
              class="relative bg-gradient-to-br from-varroc-dark to-black border border-varroc-border p-8 rounded-3xl flex flex-col gap-6 min-h-[360px] card-hover">
              <div class="flex justify-between items-start">
                <div class="w-12 h-12 bg-varroc-accent/10 rounded-xl flex items-center justify-center">
                  <svg class="w-7 h-7 svg-fill-gradient" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
                  </svg>
                </div>
                <span class="text-xs font-semibold uppercase tracking-[0.22em] text-varroc-accent">Revenue</span>
              </div>

              <p class="flex-grow text-varroc-text-gray leading-relaxed">Enable new revenue streams through services, subscriptions, marketplaces, and value-added offerings that turn connected ecosystems into durable business models.</p>

              <div class="flex items-center gap-4 pt-4 border-t border-varroc-border">
                <div class="relative">
                  <img [src]="Images.CUSTOMER_2"
                    class="h-14 w-14 rounded-full object-cover ring-2 ring-varroc-accent/50">
                  <div
                    class="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-varroc-dark">
                  </div>
                </div>
                <div class="flex-1">
                  <p class="font-bold text-white text-lg">Commercial Growth Leaders</p>
                  <p class="text-sm text-varroc-text-gray">Subscriptions, marketplaces, and connected commerce</p>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-shrink-0 w-80 md:w-96 relative group">
            <div
              class="absolute inset-0 bg-gradient-to-br from-varroc-accent/20 to-transparent rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            </div>
            <div
              class="relative bg-gradient-to-br from-varroc-dark to-black border border-varroc-border p-8 rounded-3xl flex flex-col gap-6 min-h-[360px] card-hover">
              <div class="flex justify-between items-start">
                <div class="w-12 h-12 bg-varroc-accent/10 rounded-xl flex items-center justify-center">
                  <svg class="w-7 h-7 svg-fill-gradient" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
                  </svg>
                </div>
                <span class="text-xs font-semibold uppercase tracking-[0.22em] text-varroc-accent">Efficiency</span>
              </div>

              <p class="flex-grow text-varroc-text-gray leading-relaxed">Improve operational efficiency with real-time insights, automation, and connected intelligence that keep devices, fleets, and workflows visible and in control.</p>

              <div class="flex items-center gap-4 pt-4 border-t border-varroc-border">
                <div class="relative">
                  <img [src]="Images.CUSTOMER_3"
                    class="h-14 w-14 rounded-full object-cover ring-2 ring-varroc-accent/50">
                  <div
                    class="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-varroc-dark">
                  </div>
                </div>
                <div class="flex-1">
                  <p class="font-bold text-white text-lg">Operations & Fleet Teams</p>
                  <p class="text-sm text-varroc-text-gray">Visibility, optimization, and automation at scale</p>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-shrink-0 w-80 md:w-96 relative group">
            <div
              class="absolute inset-0 bg-gradient-to-br from-varroc-accent/20 to-transparent rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            </div>
            <div
              class="relative bg-gradient-to-br from-varroc-dark to-black border border-varroc-border p-8 rounded-3xl flex flex-col gap-6 min-h-[360px] card-hover">
              <div class="flex justify-between items-start">
                <div class="w-12 h-12 bg-varroc-accent/10 rounded-xl flex items-center justify-center">
                  <svg class="w-7 h-7 svg-fill-gradient" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
                  </svg>
                </div>
                <span class="text-xs font-semibold uppercase tracking-[0.22em] text-varroc-accent">Safety</span>
              </div>

              <p class="flex-grow text-varroc-text-gray leading-relaxed">Stay informed with real-time vehicle insights, alerts, and proactive notifications that help deliver safer driving and a smarter connected ownership experience.</p>

              <div class="flex items-center gap-4 pt-4 border-t border-varroc-border">
                <div class="relative">
                  <img [src]="Images.CUSTOMER_4"
                    class="h-14 w-14 rounded-full object-cover ring-2 ring-varroc-accent/50">
                  <div
                    class="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-varroc-dark">
                  </div>
                </div>
                <div class="flex-1">
                  <p class="font-bold text-white text-lg">Connected Drivers</p>
                  <p class="text-sm text-varroc-text-gray">Real-time alerts, assistance, and ownership visibility</p>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-shrink-0 w-80 md:w-96 relative group">
            <div
              class="absolute inset-0 bg-gradient-to-br from-varroc-accent/20 to-transparent rounded-3xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500">
            </div>
            <div
              class="relative bg-gradient-to-br from-varroc-dark to-black border border-varroc-border p-8 rounded-3xl flex flex-col gap-6 min-h-[360px] card-hover">
              <div class="flex justify-between items-start">
                <div class="w-12 h-12 bg-varroc-accent/10 rounded-xl flex items-center justify-center">
                  <svg class="w-7 h-7 svg-fill-gradient" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" />
                  </svg>
                </div>
                <span class="text-xs font-semibold uppercase tracking-[0.22em] text-varroc-accent">Engagement</span>
              </div>

              <p class="flex-grow text-varroc-text-gray leading-relaxed">Access value-added services, app ecosystems, rewards, and ongoing lifecycle communication that keep users engaged long after initial activation.</p>

              <div class="flex items-center gap-4 pt-4 border-t border-varroc-border">
                <div class="relative">
                  <img [src]="Images.CUSTOMER_5"
                    class="h-14 w-14 rounded-full object-cover ring-2 ring-varroc-accent/50">
                  <div
                    class="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-varroc-dark">
                  </div>
                </div>
                <div class="flex-1">
                  <p class="font-bold text-white text-lg">Adoption & Lifecycle Teams</p>
                  <p class="text-sm text-varroc-text-gray">Rewards, campaigns, and continuous engagement</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Carousel Controls -->
        <div class="flex gap-3 justify-start mt-12">
          <button (click)="scrollTestimonialsLeft()"
            class="h-14 w-14 bg-gradient-to-br from-varroc-dark to-black border border-varroc-border hover:border-varroc-accent rounded-full p-2 transition-all duration-300 hover:shadow-neon group">
            <i class='bx bx-chevron-left text-2xl text-white group-hover:icon-gradient transition-colors'></i>
          </button>
          <button (click)="scrollTestimonialsRight()"
            class="h-14 w-14 bg-gradient-to-br from-varroc-dark to-black border border-varroc-border hover:border-varroc-accent rounded-full p-2 transition-all duration-300 hover:shadow-neon group">
            <i class='bx bx-chevron-right text-2xl text-white group-hover:icon-gradient transition-colors'></i>
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- CALL TO ACTION -->
  <section class="dashboard-section bg-varroc-darker">
    <div class="max-w-7xl mx-auto px-6">
      <div class="max-w-5xl mr-auto text-left dashboard-section-header">
        <h2 class="dashboard-major-title text-4xl md:text-5xl font-bold text-white">Transform Real-Time Data into Actionable Business & User Insights</h2>

        <p class="text-lg leading-relaxed text-varroc-text-gray max-w-3xl">Transform connected driving data into safer operations, richer experiences, measurable engagement, and scalable digital growth across business and consumer journeys.</p>
      </div>

      <div class="max-w-4xl mr-auto text-left">
        <div class="flex flex-col sm:flex-row gap-4 justify-start items-start">
          <a routerLink={{Routes.contact}}
            class="bg-varroc-accent px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all duration-300 font-medium text-lg transform hover:scale-105 turn_driving_data_book_a_demo_button">
            Book a Demo
          </a>
          <a href="mailto:{{SupportEmail}}"
            class="border border-varroc-border px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-dark transition-all duration-300 font-medium text-lg transform hover:scale-105 turn_driving_data_contact_us_button">
            Contact Us
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- WE ARE HERE TO HELP -->
  <section class="dashboard-section bg-black">
    <div class="max-w-7xl mx-auto px-6">
      <div class="max-w-4xl mr-auto text-left dashboard-section-header">
        <!-- Icon -->
        <div class="w-10 h-10 bg-varroc-accent/10 rounded-full flex items-center justify-center mb-8">
          <!-- <i class='bx bx-support text-4xl icon-gradient'></i> -->
        </div>

        <!-- Title -->
        <h2 class="dashboard-major-title text-4xl md:text-5xl font-bold text-white">Get Started with Connected Mobility, IIOT & Intelligent Enterprise Solutions</h2>

        <!-- Description -->
        <p class="max-w-3xl text-lg leading-relaxed text-varroc-text-gray">
          Whether you are building connected experiences for businesses or individuals, our team can help you plan the right platform, services, and rollout approach for your use case.
        </p>
      </div>

      <div class="max-w-4xl mr-auto text-left">
        <!-- Contact Button -->
        <div class="flex flex-col items-start gap-4">
          <a href="mailto:vc.support@varroc.com"
            class="bg-varroc-accent px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all duration-300 font-medium text-lg transform hover:scale-105 inline-block we_are_here_to_help_email_click">
            {{SupportEmail}}
          </a>
        </div>
      </div>
    </div>
  </section>


</main>